// Lightweight first-party funnel analytics helper.
//
// Fires a pageview ping to /api/funnels/pageview on mount of a tracked
// landing page. Anonymous, no cookie, no PII. The backend stamps it
// with a timestamp and aggregates into per-source view/signup/
// conversion-rate stats on the admin dashboard.
import { useEffect } from 'react';
import { api } from '../App';

export function useFunnelPageview({ path, pillar, source } = {}) {
  useEffect(() => {
    // Fire-and-forget, analytics must never break the page.
    api.post('/funnels/pageview', { path, pillar, source }).catch(() => {});
  }, [path, pillar, source]);
}
